import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/Card'
import { formatInteger, formatPercent } from './formatters'
import type { ChannelMixPanel } from '@/types/analytics'

const PALETTE = ['#7fffe4', '#22d3ee', '#a78bfa', '#f472b6', '#fbbf24', '#34d399', '#fb7185']

interface ChannelMixCardProps {
  data: ChannelMixPanel
}

export function ChannelMixCard({ data }: ChannelMixCardProps) {
  return (
    <Card className="p-4">
      <CardHeader className="px-0 pb-3">
        <CardTitle className="text-base">Channel mix</CardTitle>
        <CardDescription>Where conversations start</CardDescription>
      </CardHeader>
      <CardContent className="px-0">
        <div className="flex items-center gap-4">
          <div className="w-32 h-32 relative">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={data.slices} dataKey="count" nameKey="label" innerRadius={36} outerRadius={56} paddingAngle={2}>
                  {data.slices.map((_, i) => (
                    <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
                  ))}
                </Pie>
                <Tooltip contentStyle={{ background: 'var(--background)', border: '1px solid var(--border)' }} />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
              <div className="text-lg font-semibold tabular-nums">{formatInteger(data.total)}</div>
              <div className="text-[10px] uppercase text-muted-foreground">this period</div>
            </div>
          </div>
          <ul className="flex-1 text-xs space-y-1">
            {data.slices.map((slice, i) => (
              <li key={slice.source} className="flex items-center justify-between gap-2">
                <span className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full" style={{ background: PALETTE[i % PALETTE.length] }} />
                  {slice.label}
                </span>
                <span className="tabular-nums text-muted-foreground">
                  {formatInteger(slice.count)} · {formatPercent(slice.pct, 0)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </CardContent>
    </Card>
  )
}
